import React, { useState } from 'react';
import LandingNav from '../../components/landing/LandingNav';
import LandingFooter from '../../components/landing/LandingFooter';

const API_BASE = process.env.REACT_APP_API_URL || '/api/v1';

const CATEGORIES = [
  {
    id: 'auth',
    label: 'Autenticação',
    color: '#6366f1',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/auth/login',
        summary: 'Login de usuário',
        description: 'Autentica com e-mail e senha. Retorna um token JWT válido por 8 horas para uso nos endpoints protegidos.',
        request: `{
  "email": "admin@bringhubfrete.com.br",
  "password": "Admin@123"
}`,
        response: `{
  "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
  "user": {
    "id": "uuid-here",
    "name": "Administrador",
    "email": "admin@bringhubfrete.com.br",
    "role": "admin"
  }
}`,
      },
      {
        method: 'GET',
        path: '/api/v1/auth/me',
        summary: 'Dados do usuário logado',
        description: 'Retorna os dados do usuário autenticado pelo token JWT.',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{
  "id": "uuid-here",
  "name": "Administrador",
  "email": "admin@bringhubfrete.com.br",
  "role": "admin",
  "status": "active"
}`,
      },
    ],
  },
  {
    id: 'quote',
    label: 'Cotação Unificada',
    color: '#0ea5e9',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/quote',
        summary: 'Cotar em todas as transportadoras ativas',
        description: 'Consulta o frete em todas as transportadoras habilitadas pelo usuário (Correios, Jadlog, Loggi e J&T Express) e retorna as opções combinadas em um único array, ordenado do mais barato para o mais caro. Aceita autenticação via Bearer Token ou X-Api-Key.',
        auth: 'Bearer Token ou X-Api-Key',
        request: `{
  "cepOrigem": "01310-100",
  "cepDestino": "20040-020",
  "peso": 500,
  "comprimento": 20,
  "largura": 15,
  "altura": 10,
  "vlDeclarado": 150.00
}`,
        response: `{
  "success": true,
  "data": {
    "opcoes": [
      {
        "transportadora": "Correios",
        "codigoServico": "03298",
        "descricao": "PAC",
        "valorFrete": 25.50,
        "valorBase": 22.30,
        "prazoEntrega": 5,
        "dataMaxima": "2024-01-22",
        "entregaDomiciliar": "S",
        "entregaSabado": "N",
        "erro": null
      },
      {
        "transportadora": "Loggi",
        "codigoServico": "loggi-expressa",
        "descricao": "Loggi Expressa",
        "valorFrete": 28.90,
        "valorBase": 24.00,
        "prazoEntrega": 3,
        "dataMaxima": null,
        "entregaDomiciliar": null,
        "entregaSabado": null,
        "erro": null
      },
      {
        "transportadora": "Jadlog",
        "codigoServico": "3",
        "descricao": "Jadlog .Package",
        "valorFrete": 33.10,
        "valorBase": 29.50,
        "prazoEntrega": 4,
        "dataMaxima": null,
        "entregaDomiciliar": null,
        "entregaSabado": null,
        "erro": null
      },
      {
        "transportadora": "Correios",
        "codigoServico": "03220",
        "descricao": "SEDEX",
        "valorFrete": 42.80,
        "valorBase": 38.50,
        "prazoEntrega": 2,
        "dataMaxima": "2024-01-17",
        "entregaDomiciliar": "S",
        "entregaSabado": "S",
        "erro": null
      },
      {
        "transportadora": "J&T Express",
        "codigoServico": null,
        "descricao": "J&T Express",
        "valorFrete": null,
        "valorBase": null,
        "prazoEntrega": null,
        "dataMaxima": null,
        "entregaDomiciliar": null,
        "entregaSabado": null,
        "erro": "J&T Express: credenciais inválidas ou não configuradas"
      }
    ],
    "transportadorasConsultadas": ["correios", "jadlog", "loggi", "jt-express"]
  }
}`,
      },
    ],
  },
  {
    id: 'correios',
    label: 'Correios',
    color: '#f59e0b',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/correios/quote',
        summary: 'Cotação de frete',
        description: 'Cotar envio pelos Correios. Retorna as opções disponíveis com preço e prazo, ordenadas pelo valor.',
        auth: 'X-Api-Key',
        request: `{
  "cepOrigem": "01310100",
  "cepDestino": "20040020",
  "peso": 0.3,
  "comprimento": 20,
  "largura": 15,
  "altura": 10,
  "vlDeclarado": 150.00
}`,
        response: `{
  "transportadora": "correios",
  "opcoes": [
    {
      "transportadora": "correios",
      "codigoServico": "03298",
      "descricao": "PAC",
      "valorFrete": 25.50,
      "valorBase": 22.30,
      "prazoEntrega": 5,
      "dataMaxima": "2024-01-22",
      "entregaDomiciliar": true,
      "entregaSabado": false,
      "erro": null
    },
    {
      "transportadora": "correios",
      "codigoServico": "03220",
      "descricao": "SEDEX",
      "valorFrete": 42.80,
      "valorBase": 38.50,
      "prazoEntrega": 2,
      "dataMaxima": "2024-01-17",
      "entregaDomiciliar": true,
      "entregaSabado": true,
      "erro": null
    }
  ]
}`,
      },
      {
        method: 'GET',
        path: '/api/v1/correios/tracking/:codigo',
        summary: 'Rastreamento de objeto',
        description: 'Rastreia um objeto pelos Correios usando o código de rastreio.',
        auth: 'X-Api-Key',
        response: `{
  "codigo": "SX123456789BR",
  "eventos": [
    {
      "descricao": "Objeto postado",
      "data": "2024-01-15T10:30:00Z",
      "local": "Agência dos Correios - SP"
    }
  ]
}`,
      },
      {
        method: 'GET',
        path: '/api/v1/correios/cep/:cep',
        summary: 'Consulta de CEP',
        description: 'Retorna os dados de endereço de um CEP válido.',
        auth: 'X-Api-Key',
        response: `{
  "cep": "01310-100",
  "logradouro": "Avenida Paulista",
  "bairro": "Bela Vista",
  "localidade": "São Paulo",
  "uf": "SP"
}`,
      },
    ],
  },
  {
    id: 'jadlog',
    label: 'Jadlog',
    color: '#dc2626',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/jadlog/quote',
        summary: 'Cotação de frete',
        description: 'Cotar envio pela Jadlog. Consulta as modalidades .Package, .Com e Rodoviário e retorna as opções ordenadas pelo valor.',
        auth: 'X-Api-Key',
        request: `{
  "cepOrigem": "01310100",
  "cepDestino": "20040020",
  "peso": 500,
  "comprimento": 20,
  "largura": 15,
  "altura": 10,
  "vlDeclarado": 150.00
}`,
        response: `{
  "transportadora": "jadlog",
  "opcoes": [
    {
      "transportadora": "Jadlog",
      "codigoServico": "3",
      "descricao": "Jadlog .Package",
      "valorFrete": 29.90,
      "valorBase": 26.50,
      "prazoEntrega": 4,
      "dataMaxima": null,
      "entregaDomiciliar": null,
      "entregaSabado": null,
      "erro": null
    },
    {
      "transportadora": "Jadlog",
      "codigoServico": "9",
      "descricao": "Jadlog .Com",
      "valorFrete": 41.20,
      "valorBase": 36.80,
      "prazoEntrega": 2,
      "dataMaxima": null,
      "entregaDomiciliar": null,
      "entregaSabado": null,
      "erro": null
    }
  ]
}`,
      },
    ],
  },
  {
    id: 'loggi',
    label: 'Loggi',
    color: '#7c3aed',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/loggi/quote',
        summary: 'Cotação de frete',
        description: 'Cotar envio pela Loggi para a rota informada. Retorna até duas opções (Loggi Econômico e Loggi Expresso).',
        auth: 'X-Api-Key',
        request: `{
  "cepOrigem": "01310100",
  "cepDestino": "20040020",
  "peso": 12000,
  "comprimento": 55,
  "largura": 55,
  "altura": 100,
  "vlDeclarado": 87.35
}`,
        response: `{
  "transportadora": "loggi",
  "opcoes": [
    {
      "transportadora": "Loggi",
      "codigoServico": "FREIGHT_TYPE_ECONOMIC",
      "descricao": "Loggi Econômico",
      "valorFrete": 7.15,
      "valorBase": 3.59,
      "prazoEntrega": 3,
      "dataMaxima": null,
      "entregaDomiciliar": null,
      "entregaSabado": null,
      "erro": null
    },
    {
      "transportadora": "Loggi",
      "codigoServico": "FREIGHT_TYPE_EXPRESS",
      "descricao": "Loggi Expresso",
      "valorFrete": 12.45,
      "valorBase": 3.59,
      "prazoEntrega": 1,
      "dataMaxima": null,
      "entregaDomiciliar": null,
      "entregaSabado": null,
      "erro": null
    }
  ]
}`,
      },
    ],
  },
  {
    id: 'jt-express',
    label: 'J&T Express',
    color: '#e11d48',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/jt-express/quote',
        summary: 'Cotação de frete',
        description: 'Cotar envio pela J&T Express para a rota informada. ⚠️ A API da J&T (Tariff Checking) não aceita CEP diretamente — exige códigos internos de origem/destino (sendSiteCode/destAreaCode) fornecidos pela transportadora, configurados previamente na conta. O endpoint não retorna prazo de entrega.',
        auth: 'X-Api-Key',
        request: `{
  "cepOrigem": "01310100",
  "cepDestino": "20040020",
  "peso": 1000
}`,
        response: `{
  "transportadora": "jt-express",
  "opcoes": [
    {
      "transportadora": "J&T Express",
      "codigoServico": "EZ",
      "descricao": "J&T Express EZ",
      "valorFrete": 9000,
      "valorBase": null,
      "prazoEntrega": null,
      "dataMaxima": null,
      "entregaDomiciliar": null,
      "entregaSabado": null,
      "erro": null
    }
  ]
}`,
      },
    ],
  },
  {
    id: 'freight',
    label: 'Fretes',
    color: '#10b981',
    endpoints: [
      {
        method: 'GET',
        path: '/api/v1/freight/carriers',
        summary: 'Listar transportadoras',
        description: 'Lista todas as transportadoras disponíveis com a configuração atual do usuário.',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{
  "carriers": [
    {
      "id": 1,
      "name": "Correios",
      "slug": "correios",
      "isEnabled": true,
      "useOwnCredentials": false,
      "lastTestOk": true
    }
  ]
}`,
      },
      {
        method: 'PUT',
        path: '/api/v1/freight/carriers/:carrierId/config',
        summary: 'Salvar configuração de transportadora',
        description: 'Habilita/desabilita uma transportadora e salva credenciais próprias (opcional).',
        auth: 'Bearer Token ou X-Api-Key',
        request: `{
  "isEnabled": true,
  "useOwnCredentials": true,
  "credentials": {
    "id_correios": "meu.usuario@empresa.com",
    "codigo_acesso": "sua_chave_aqui",
    "cartao_postagem": "0000000000",
    "contrato": "0000000000",
    "dr": "10"
  }
}`,
        response: `{ "message": "Configuração salva com sucesso" }`,
      },
      {
        method: 'POST',
        path: '/api/v1/freight/carriers/:carrierId/test',
        summary: 'Testar conexão',
        description: 'Testa a conectividade com a API da transportadora usando as credenciais configuradas.',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{
  "success": true,
  "message": "Conexão estabelecida com sucesso",
  "testedAt": "2024-01-15T10:30:00Z"
}`,
      },
      {
        method: 'GET',
        path: '/api/v1/freight/distance-brackets',
        summary: 'Listar faixas de KM',
        description: 'Retorna as faixas de quilometragem configuradas para o módulo "Frete por Distância" (Mapbox).',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{
  "success": true,
  "data": {
    "brackets": [
      { "id": 1, "km_de": 0, "km_ate": 10, "tipo": "por_km", "valor": 5.00, "sort_order": 0 },
      { "id": 2, "km_de": 11, "km_ate": 50, "tipo": "por_km", "valor": 15.00, "sort_order": 1 },
      { "id": 3, "km_de": 51, "km_ate": 200, "tipo": "fixo", "valor": 300.00, "sort_order": 2 }
    ]
  }
}`,
      },
      {
        method: 'PUT',
        path: '/api/v1/freight/distance-brackets',
        summary: 'Salvar faixas de KM',
        description: 'Substitui todas as faixas do usuário. `tipo` "por_km" multiplica o valor pela distância total; "fixo" cobra um valor único para toda a faixa.',
        auth: 'Bearer Token ou X-Api-Key',
        request: `{
  "brackets": [
    { "kmDe": 0, "kmAte": 10, "tipo": "por_km", "valor": 5.00 },
    { "kmDe": 11, "kmAte": 50, "tipo": "por_km", "valor": 15.00 },
    { "kmDe": 51, "kmAte": 200, "tipo": "fixo", "valor": 300.00 }
  ]
}`,
        response: `{ "success": true, "message": "Faixas de KM salvas com sucesso" }`,
      },
    ],
  },
  {
    id: 'distancia',
    label: 'Frete por Distância',
    color: '#0891b2',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/distancia-mapbox/quote',
        summary: 'Cotar frete por distância',
        description: 'Calcula o valor do frete com base na distância rodoviária (Mapbox Directions) entre a origem cadastrada em Fretes e o CEP de destino, aplicando a faixa de KM configurada. O campo cepOrigem é ignorado — a origem é sempre a cadastrada.',
        auth: 'X-Api-Key',
        request: `{
  "cepDestino": "20040-020",
  "peso": 500,
  "comprimento": 20,
  "largura": 15,
  "altura": 10
}`,
        response: `{
  "transportadora": "distancia-mapbox",
  "opcoes": [
    {
      "transportadora": "Frete por Distância",
      "codigoServico": "11-50km",
      "descricao": "Frete por Distância (25.0 km)",
      "valorFrete": 375.00,
      "valorBase": 375.00,
      "prazoEntrega": null,
      "dataMaxima": null,
      "entregaDomiciliar": null,
      "entregaSabado": null,
      "erro": null
    }
  ]
}`,
      },
    ],
  },
  {
    id: 'etiquetas',
    label: 'Emissão de Etiquetas',
    color: '#0891b2',
    endpoints: [
      {
        method: 'POST',
        path: '/api/v1/jadlog/etiqueta',
        summary: 'Emitir etiqueta — Jadlog',
        description: 'Cria o pedido na Jadlog e retorna o código de rastreio. Mesmo padrão de endpoint existe para /correios/etiqueta, /loggi/etiqueta e /jt-express/etiqueta.',
        auth: 'X-Api-Key',
        request: `{
  "remetente": {
    "nome": "Loja Exemplo LTDA",
    "documento": "12345678000199",
    "telefone": "11999999999",
    "cep": "01310-100",
    "logradouro": "Avenida Paulista",
    "numero": "100",
    "bairro": "Bela Vista",
    "cidade": "São Paulo",
    "uf": "SP"
  },
  "destinatario": {
    "nome": "João da Silva",
    "documento": "12345678900",
    "telefone": "11988888888",
    "cep": "20040-020",
    "logradouro": "Rua do Ouvidor",
    "numero": "50",
    "bairro": "Centro",
    "cidade": "Rio de Janeiro",
    "uf": "RJ"
  },
  "peso": 500,
  "comprimento": 20,
  "largura": 15,
  "altura": 10,
  "vlDeclarado": 50.00,
  "conteudo": "Mercadoria"
}`,
        response: `{
  "transportadora": "Jadlog",
  "sucesso": true,
  "codigoRastreio": "00000000000000",
  "numeroPedido": "123456789",
  "etiquetaBase64": null,
  "etiquetaUrl": null,
  "erro": null
}`,
      },
    ],
  },
  {
    id: 'tokens',
    label: 'Tokens de API',
    color: '#f59e0b',
    endpoints: [
      {
        method: 'GET',
        path: '/api/v1/freight/tokens',
        summary: 'Listar tokens',
        description: 'Retorna todos os tokens de API do usuário autenticado. O valor completo não é exibido — apenas o prefixo para identificação.',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{
  "success": true,
  "data": {
    "tokens": [
      {
        "id": 1,
        "name": "Loja Principal",
        "token_preview": "bhf_1a2b",
        "is_active": true,
        "last_used_at": null,
        "created_at": "2024-01-15T10:00:00Z"
      }
    ]
  }
}`,
      },
      {
        method: 'POST',
        path: '/api/v1/freight/tokens',
        summary: 'Gerar token',
        description: 'Gera um novo token de API. O valor completo é retornado apenas nesta resposta — armazene-o com segurança, pois não será exibido novamente.',
        auth: 'Bearer Token ou X-Api-Key',
        request: `{ "name": "Loja Principal" }`,
        response: `{
  "success": true,
  "data": {
    "id": 1,
    "name": "Loja Principal",
    "token": "bhf_1a2b3c4d5e6f..."
  }
}`,
      },
      {
        method: 'PATCH',
        path: '/api/v1/freight/tokens/:id/toggle',
        summary: 'Ativar / desativar token',
        description: 'Alterna o status do token. Tokens inativos são rejeitados e retornam 401.',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{ "success": true, "message": "Status do token atualizado" }`,
      },
      {
        method: 'DELETE',
        path: '/api/v1/freight/tokens/:id',
        summary: 'Remover token',
        description: 'Remove permanentemente o token. Requisições que usavam esta chave passarão a receber 401.',
        auth: 'Bearer Token ou X-Api-Key',
        response: `{ "success": true, "message": "Token removido" }`,
      },
    ],
  },
  {
    id: 'users',
    label: 'Usuários (Admin)',
    color: '#8b5cf6',
    endpoints: [
      {
        method: 'GET',
        path: '/api/v1/admin/users',
        summary: 'Listar usuários',
        description: 'Lista todos os usuários com suporte a filtros de busca, status, role e paginação.',
        auth: 'Bearer Token ou X-Api-Key (admin)',
        response: `{
  "data": [...],
  "pagination": {
    "total": 42,
    "page": 1,
    "limit": 20,
    "pages": 3
  }
}`,
      },
      {
        method: 'POST',
        path: '/api/v1/admin/users',
        summary: 'Criar usuário',
        description: 'Cria um novo usuário na plataforma.',
        auth: 'Bearer Token ou X-Api-Key (admin)',
        request: `{
  "name": "João Silva",
  "email": "joao@empresa.com.br",
  "password": "Senha@123",
  "role": "user"
}`,
        response: `{
  "id": "uuid-here",
  "name": "João Silva",
  "email": "joao@empresa.com.br",
  "role": "user",
  "status": "active"
}`,
      },
    ],
  },
];

const METHOD_COLORS = {
  GET: { bg: '#dbeafe', color: '#1d4ed8' },
  POST: { bg: '#dcfce7', color: '#15803d' },
  PUT: { bg: '#fef9c3', color: '#a16207' },
  DELETE: { bg: '#fee2e2', color: '#b91c1c' },
  PATCH: { bg: '#f3e8ff', color: '#7e22ce' },
};

function EndpointCard({ ep }) {
  const [open, setOpen] = useState(false);
  const mc = METHOD_COLORS[ep.method] || METHOD_COLORS.GET;

  return (
    <div style={s.card}>
      <button style={s.cardHeader} onClick={() => setOpen(!open)}>
        <div style={s.cardLeft}>
          <span style={{ ...s.badge, background: mc.bg, color: mc.color }}>{ep.method}</span>
          <code style={s.path}>{ep.path}</code>
        </div>
        <div style={s.cardRight}>
          <span style={s.summary}>{ep.summary}</span>
          {ep.auth && <span style={s.authBadge}>{ep.auth}</span>}
          <span style={{ color: '#9ca3af', marginLeft: 8 }}>{open ? '▲' : '▼'}</span>
        </div>
      </button>

      {open && (
        <div style={s.cardBody}>
          <p style={s.description}>{ep.description}</p>
          <div style={s.blocks}>
            {ep.request && (
              <div style={s.block}>
                <div style={s.blockLabel}>Request Body</div>
                <pre style={s.code}>{ep.request}</pre>
              </div>
            )}
            {ep.response && (
              <div style={s.block}>
                <div style={s.blockLabel}>Response 200</div>
                <pre style={s.code}>{ep.response}</pre>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default function DocsPage() {
  const [activeCategory, setActiveCategory] = useState('auth');
  const category = CATEGORIES.find(c => c.id === activeCategory);

  return (
    <div style={s.root}>
      <LandingNav />
      <div style={s.hero}>
        <h1 style={s.heroTitle}>Documentação da API</h1>
        <p style={s.heroSub}>
          Integre sua plataforma ao BringHub Frete com nossa API REST.
          Consulte preços, rastreie objetos e gerencie transportadoras de forma simples.
        </p>
        <div style={s.heroBadges}>
          <span style={s.heroBadge}>REST / JSON</span>
          <span style={s.heroBadge}>JWT + API Key</span>
          <span style={s.heroBadge}>Rate limit: 200 req/15min</span>
          <span style={{ ...s.heroBadge, background: '#d1fae5', color: '#065f46' }}>Base URL: {API_BASE}</span>
        </div>
      </div>

      <div style={s.layout}>
        {/* Sidebar */}
        <aside style={s.sidebar}>
          <div style={s.sidebarSection}>
            <div style={s.sidebarTitle}>Autenticação</div>
            <div style={s.authInfo}>
              <p style={s.authPara}><strong>JWT (Bearer)</strong> — Endpoints admin e de usuário. Envie o token no header:</p>
              <code style={s.inlineCode}>Authorization: Bearer &lt;token&gt;</code>
              <p style={{ ...s.authPara, marginTop: 12 }}><strong>API Key</strong> — Endpoints públicos de cotação e rastreamento:</p>
              <code style={s.inlineCode}>X-Api-Key: &lt;sua-chave&gt;</code>
            </div>
          </div>
          <div style={s.sidebarSection}>
            <div style={s.sidebarTitle}>Endpoints</div>
            {CATEGORIES.map(c => (
              <button
                key={c.id}
                onClick={() => setActiveCategory(c.id)}
                style={{
                  ...s.sidebarItem,
                  background: activeCategory === c.id ? `${c.color}18` : 'transparent',
                  color: activeCategory === c.id ? c.color : '#374151',
                  borderLeft: `3px solid ${activeCategory === c.id ? c.color : 'transparent'}`,
                }}
              >
                {c.label}
                <span style={{ ...s.countBadge, background: activeCategory === c.id ? c.color : '#e5e7eb', color: activeCategory === c.id ? '#fff' : '#6b7280' }}>
                  {c.endpoints.length}
                </span>
              </button>
            ))}
          </div>
          <div style={s.sidebarSection}>
            <div style={s.sidebarTitle}>Spec completa</div>
            <a href={`${API_BASE}/openapi.json`} target="_blank" rel="noreferrer" style={s.specLink}>
              openapi.json ↗
            </a>
            <a href={`${API_BASE}/docs`} target="_blank" rel="noreferrer" style={{ ...s.specLink, marginTop: 6 }}>
              Swagger UI ↗
            </a>
          </div>
        </aside>

        {/* Content */}
        <main style={s.main}>
          <div style={{ ...s.categoryHeader, borderLeft: `4px solid ${category.color}` }}>
            <h2 style={{ ...s.categoryTitle, color: category.color }}>{category.label}</h2>
            <span style={s.categoryCount}>{category.endpoints.length} endpoints</span>
          </div>
          <div style={s.endpointList}>
            {category.endpoints.map((ep, i) => (
              <EndpointCard key={i} ep={ep} />
            ))}
          </div>
        </main>
      </div>
      <LandingFooter />
    </div>
  );
}

const s = {
  root: { fontFamily: 'Inter, sans-serif', background: '#f9fafb', minHeight: '100vh' },
  hero: {
    background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
    padding: '100px 24px 60px',
    textAlign: 'center',
  },
  heroTitle: { fontSize: 'clamp(28px, 5vw, 48px)', fontWeight: 800, color: '#fff', margin: '0 0 16px' },
  heroSub: { fontSize: 18, color: 'rgba(255,255,255,0.8)', maxWidth: 600, margin: '0 auto 28px', lineHeight: 1.6 },
  heroBadges: { display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' },
  heroBadge: { background: 'rgba(255,255,255,0.15)', color: '#fff', padding: '6px 14px', borderRadius: 20, fontSize: 13, fontWeight: 500 },
  layout: { display: 'flex', maxWidth: 1200, margin: '0 auto', padding: '40px 24px', gap: 32, alignItems: 'flex-start' },
  sidebar: { width: 260, flexShrink: 0, position: 'sticky', top: 24 },
  sidebarSection: { background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', padding: '16px', marginBottom: 16 },
  sidebarTitle: { fontSize: 11, fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: 12 },
  authInfo: {},
  authPara: { fontSize: 13, color: '#374151', margin: '0 0 6px', lineHeight: 1.5 },
  inlineCode: { display: 'block', background: '#f3f4f6', padding: '6px 10px', borderRadius: 6, fontSize: 12, color: '#1e40af', wordBreak: 'break-all' },
  sidebarItem: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    width: '100%', padding: '8px 10px', border: 'none', borderRadius: 6,
    fontSize: 13, fontWeight: 500, cursor: 'pointer', textAlign: 'left', transition: 'all 0.15s', marginBottom: 2,
  },
  countBadge: { fontSize: 11, fontWeight: 700, borderRadius: 10, padding: '2px 7px' },
  specLink: { display: 'block', fontSize: 13, color: '#1e40af', textDecoration: 'none', fontWeight: 500 },
  main: { flex: 1, minWidth: 0 },
  categoryHeader: { display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', background: '#fff', borderRadius: 10, marginBottom: 16, border: '1px solid #e5e7eb' },
  categoryTitle: { margin: 0, fontSize: 18, fontWeight: 700 },
  categoryCount: { fontSize: 12, color: '#6b7280', background: '#f3f4f6', padding: '2px 8px', borderRadius: 10 },
  endpointList: { display: 'flex', flexDirection: 'column', gap: 8 },
  card: { background: '#fff', borderRadius: 10, border: '1px solid #e5e7eb', overflow: 'hidden' },
  cardHeader: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    width: '100%', padding: '14px 16px', background: 'none', border: 'none', cursor: 'pointer', gap: 12,
  },
  cardLeft: { display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 },
  cardRight: { display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 },
  badge: { fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 5, flexShrink: 0 },
  path: { fontSize: 13, color: '#111827', fontFamily: 'monospace' },
  summary: { fontSize: 13, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  authBadge: { fontSize: 11, background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: 10, flexShrink: 0 },
  cardBody: { padding: '0 16px 16px', borderTop: '1px solid #f3f4f6' },
  description: { fontSize: 14, color: '#374151', margin: '14px 0 12px', lineHeight: 1.6 },
  blocks: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 },
  block: {},
  blockLabel: { fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 6 },
  code: { background: '#0f172a', color: '#e2e8f0', padding: '12px 14px', borderRadius: 8, fontSize: 12, margin: 0, overflowX: 'auto', lineHeight: 1.6 },
};
